import { render } from "./QuestionFormMoreAnswer.vue?vue&type=template&id=7ec0b704&scoped=true&ts=true"
import script from "./QuestionFormMoreAnswer.vue?vue&type=script&lang=ts"
export * from "./QuestionFormMoreAnswer.vue?vue&type=script&lang=ts"

import "./QuestionFormMoreAnswer.vue?vue&type=style&index=0&id=7ec0b704&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec0b704"]])

export default __exports__